export interface CsvColumn<T> {
  header: string;
  value: (row: T) => string | number | null | undefined;
}

/**
 * Quotes a CSV cell when needed (commas, quotes, line breaks) and doubles embedded quotes.
 * @param value - Raw cell value.
 */
function toCsvCell(value: string | number | null | undefined): string {
  if (value === null || value === undefined) return '';
  const text = String(value);
  return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
}

/**
 * Builds a CSV file in the browser and downloads it. Adds a UTF-8 BOM so Excel shows
 * non-ASCII text (e.g. Cyrillic tenant names) correctly.
 * @param filename - File name without extension.
 * @param columns - Header and value accessor per column.
 * @param rows - Rows to export.
 */
export function downloadCsv<T>(filename: string, columns: CsvColumn<T>[], rows: T[]): void {
  const lines = [columns.map((column) => toCsvCell(column.header)).join(',')];
  for (const row of rows) {
    lines.push(columns.map((column) => toCsvCell(column.value(row))).join(','));
  }
  const blob = new Blob(['﻿' + lines.join('\r\n')], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${filename}.csv`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
